import { createRouter, createWebHistory } from 'vue-router'

import LoginView from '../apps/login.vue' 

// Dashboard Layout here _________________________________________________________________
import MainLayout from '../apps/MainLayout.vue'
// import DashboardOverview from '../apps/DashboardOverview.vue'

// Load dynamic dashboard !!
import mainDashboardJson from '../apps/jsonForm/dashboard-home.json'
import DashboardOverview from '../templates/components/DynamicDashboardLayout.vue'

const routes = [
    {
          path    : '/'
        , redirect: '/login'
    },{
          path     : '/login'
        , name     : 'Login'
        , component: LoginView
    },{
          path     : '/'
        , name     : 'MainLayout'
        , component: MainLayout
        , meta     : { requiresAuth: true }
        , children : [{
              path     : 'dashboard'
            , name     : 'Dashboard'
            , component: DashboardOverview
            , props: { config: mainDashboardJson }
        }]
    },
    {
      // CATCH-ALL / 404 ROUTE 
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      redirect: (to) => {
          const token = localStorage.getItem('auth_token')
          const isValidToken = token && token !== 'undefined' && token !== 'null'

          // If user has token, send to /dashboard, otherwise send to /login
          return isValidToken ? '/dashboard' : '/login'
      }
  }
]

// Create Routing here 
const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const token        = localStorage.getItem('auth_token')
  const isValidToken = token && token !== 'undefined' && token !== 'null'

  if (to.meta.requiresAuth && !token) {
    // If trying to access dashboard without token, send user to login page
    next({ name: 'Login' })
  } else if (to.name === 'Login' && isValidToken) {
    next({ name: 'Dashboard' })    
  } else {
    next()
  }
})

export default router